import { isCustomPage } from 'Store/CustomPage/CustomPage.action';

export class CustomPageDispatcher {
    dispatchCustomPage(dispatch, { isCustom, name }) {
        dispatch(isCustomPage({ isCustom, name }));
    }
}

export default new CustomPageDispatcher();
